import { css } from "@compiled/react";

import { AgileVideo } from "@/components/agile-video/agile-video";
import { Picture } from "@/components/wpl/image/src";
import { Image } from "@/content/templates/template.types.ts";

import { RichTextComponent } from "../components/body-text";

type Nullable<T> = T | null;

export type TopicIntroductionProps = {
    title: string | null;
    details: string | null;
    asset?: Nullable<Image[]>;
    embedLink?: string | null;
};

const topicIntroductionWrapperCss = css({
    display: "block",
    position: "relative",
    height: "100%",
    paddingBlockStart: "16px"
});

const headerCss = css({
    marginBlockEnd: "0.83em",
    marginBlockStart: "16px"
});

const assetCss = css({
    display: "block",
    position: "relative"
});

export const TopicIntroduction = ({
    title,
    details,
    embedLink,
    asset
}: TopicIntroductionProps) => {
    const renderIntroductionAsset = () => {
        // If there's an embedLink, we expect an asset to go with it.
        if (embedLink && asset?.length)
            return (
                <AgileVideo
                    embedLink={embedLink}
                    title={title ?? ""}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    thumbnail={asset[0]!}
                />
            );

        if (asset)
            return (
                <>
                    {asset.map((asset) => (
                        <Picture
                            key={asset?.name}
                            image={{
                                src: asset?.url ?? "",
                                alt: asset?.description ?? asset?.name ?? ""
                            }}
                        />
                    ))}
                </>
            );

        return null;
    };

    return (
        <div className="topicIntroduction" css={topicIntroductionWrapperCss}>
            {title && <h2 css={headerCss}>{title}</h2>}
            <div className="topicIntroduction-body">
                <RichTextComponent text={details} name={null} />
            </div>
            <div className="topicIntroduction-asset" css={assetCss}>
                {renderIntroductionAsset()}
            </div>
        </div>
    );
};
